import { permissionsGroupLangs, permissionsLangs } from '@/constants/Roles';
import { RawRolePermission } from '@/types/roles.types';

export const getRolePermissionFilter = () => (permission: RawRolePermission): boolean => permissionsLangs[permission.id] && permissionsGroupLangs[permission.group_id];
